<template>
  <div>
    <div class="d-flex flex-column pagamento ">
      <div class="col-12 d-flex flex-wrap justify-content-center justify-content-sm-between w-75 mx-auto my-2 border border-success rounded produto">
        <div class="d-flex justify-content-center flex-column m-1">
          <span class="h5 nome m-0">{{planoOfertado.produto}}</span>
          <span class="descricao">{{planoOfertado.pacote}}</span>
        </div>
        <div class="d-flex justify-content-center flex-column promocao m-1">
          <span class="preco-cheio"><strike>{{planoOfertado.valor_cheio | formatarValorMonetario }}</strike></span>
          <h4 class="preco"><strong>{{planoOfertado.valor | formatarValorMonetario }}</strong></h4>
          <span class="text-uppercase frequencia-cobranca small" v-if="planoOfertadoEhMensal">por mês</span>
        </div>
      </div>
      <form class="mt-2 w-75 mx-auto">
        <Formulario-Credito :flagsDeControle="flagsDeControle" :listaDeErros="retorno.listaDeErros" v-model="formulario.cartao"/>
        <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex justify-content-center align-items-center">
          <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
          <b-spinner class="ml-2" variant="danger"></b-spinner>
        </div>
        <div class="d-flex justify-content-center col-8 mx-auto my-auto my-2">
          <b-button variant="btn btn-outline-secondary mr-1 col-auto" :disabled="flagsDeControle.manipulandoDados.status" @click="voltar()">Voltar</b-button>
          <b-button variant="btn btn-verde mr-1 col-auto" :disabled="flagsDeControle.manipulandoDados.status" @click="confirmar()">Confirmar</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PagamentoOferta from './js/pagamentoOferta'
export default PagamentoOferta
</script>

<style scoped>
@import "./scss/pagamentoOferta.scss";
</style>
